import { clickEater } from '../../../uiParts/clickEater-sidecar'
import { setScale } from '../../../uiParts/stevieTexts2'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { chessCamera } from '../chessCamera-sidecar'
import { chessLayers } from '../chessLayers-sidecar'
import { chessFonts } from './chessFonts-sidecar'
import type { IChessUiCanvas } from './chessUiCanvas'
import { chessUiCanvas } from './chessUiCanvas-sidecar'
import { chessUiGButtons } from './chessUiGButtons-sidecar'
import { chessUiGraphicsUtils } from './chessUiGraphicsUtils-sidecar'

interface IChessUiMessage extends IChessUiCanvas {
  textTitle: string
  textDesc: string
  textScale: number
  onOk: () => void
}
let _obj: IChessUiMessage | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
    render()
  }
  return _obj
}

const create = () => {
  let tw = 600
  let th = 700

  let canvas = chessUiCanvas.create(tw, th, chessLayers.getLayers().uiMessage)
  canvas.autoOffset = false

  let obj: IChessUiMessage = chessUiCanvas.assign<IChessUiMessage>(canvas, {
    textTitle: 'Title',
    textDesc: 'Desc',
    textScale: 1,
    onOk: () => {},
  })

  obj.buttons = [
    chessUiGButtons.create('Ok', 50, 50, () => {
      get().onOk()
      setOpen(false)
    }),
  ]

  return obj
}

export const setText = (text: string, desc: string, textScale: number = 1) => {
  let obj = get()
  obj.textTitle = text
  obj.textDesc = desc
  obj.textScale = textScale
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  chessUiCanvas.clear(obj)

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(chessFonts.get().f, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 0.4)
    obj.texts.push(_text)
    return _text
  }

  g.clear()

  let gb = chessCamera.getGameBounds()

  g.fillStyle(0x222222, 0.67)
  g.fillRect(0, 0, gb.width, gb.height)

  let w = obj.targetWidth
  let h = obj.targetHeight

  let x = (gb.width - w) / 2
  let y = (gb.height - h) / 2

  chessUiGraphicsUtils.bevelPanel(g, x, y, w, h)

  let title = addText(obj.textTitle, x + 6, y)
  stevieTexts2.setScale(title, 0.6)
  stevieTexts2.setWrapWidth(title, 9999)

  let textDesc = addText(obj.textDesc, x + 6 + 20, y + 40)
  stevieTexts2.setWrapWidth(textDesc, obj.targetWidth - 50)
  stevieTexts2.setScale(textDesc, 0.4 * obj.textScale)

  x += 20
  y += h - 60
  obj.buttons[0].x = x
  obj.buttons[0].y = y

  chessUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean, onOk = () => {}) => {
  let obj = get()
  chessUiCanvas.setOpen(obj, isOpen)
  obj.onOk = onOk
  if (isOpen) {
    update()
  }
}

export const update = () => {
  let obj = get()

  if (obj.isOpen) {
    chessUiCanvas.update(obj)
    render()
    clickEater.tempEatCursor()
  } else {
    chessUiCanvas.clear(obj)
  }
}
